export const buildSearchIndex = (documentationData) => {
  const index = [];

  const addEntry = (sectionKey, title, content) => {
    if (!content) return;
    index.push({
      sectionKey,
      title,
      content,
      searchableText: content.toLowerCase(),
    });
  };

  Object.entries(documentationData).forEach(([key, data]) => {
    addEntry(key, data.title, data.title);
    addEntry(key, data.title, data.description);
    addEntry(key, data.title, data.note);

    data.sections?.forEach((section) => {
      addEntry(key, section.heading, section.heading);
      section.paragraphs?.forEach((p) =>
        addEntry(key, section.heading, p)
      );
      section.points?.forEach((p) =>
        addEntry(key, section.heading, p)
      );
      section.steps?.forEach((s) =>
        addEntry(key, section.heading, s)
      );
      section.content &&
        addEntry(key, section.heading, section.content);
    });
  });

  return index;
};

export const searchIndex = (index, query) => {
  if (!query) return [];
  const term = query.toLowerCase();

  return index
    .filter((entry) => entry.searchableText.includes(term))
    .slice(0, 10);
};
